import React from "react";
import { inject, observer } from "mobx-react";
import { ReactComponent as LogoIcon } from "../../svg/logo.svg";
import { ReactComponent as CaretDown } from "../../svg/angle-down.svg";
import { ReactComponent as CaretUp } from "../../svg/angle-up.svg";
import { ReactComponent as LockedIcon } from '../../svg/lock-icon-locked.svg'
import { ReactComponent as SavedIcon } from "../../svg/saved-icon.svg";
import { ReactComponent as UnsavedIcon } from "../../svg/unsaved-icon.svg";
import PublishButton from "../Buttons/PublishButton";
import ShareButton from "../Buttons/ShareButton";
import ProfileIcon from "./ProfileIcon";
import Button from "../Buttons/Button";
import AuthModal from "./AuthModal";
import DesignMenu from "./DesignMenu";
import ShareMenu from "./ShareMenu";
import PublishMenu from "./PublishMenu";
// import ShareModal from "./ShareModal";
import { v4 as uuidv4 } from 'uuid'
import Projects from "./Projects";
import CallToAction from "../Inputs/CallToAction";
import AdminModal from "./AdminModal";
import PermissionsModal from "./PermissionsModal";
import Loader from "../Buttons/Loader";
import NFTModal from "../Inputs/NFTModal";
import ConfirmModal from "../Inputs/ConfirmModal";

@inject("store", 'saveStore', 'viewStore', 'errorStore', 'workAreaStore') @observer
class Header extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      title: '',
      ctaOpen: false,
      updateOpen: false,
      toggled: false
    }
  }

  async componentDidMount() {
    if(this.props.isView){
      await this.props.store.checkAuthStatus()
    }
    setTimeout(() => {
      if(process.env.REACT_APP_G_TAG_ID){
        const script = document.createElement('script')
        script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_G_TAG_ID}`
        document.head.append(script)
        let text = `window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', "${process.env.REACT_APP_G_TAG_ID}");
        if (typeof ga != 'undefined') {
            ga('require', 'ecommerce');
        }`
        const scriptBody = document.createElement('script')
        if(this.props.store.auth){
          text += `gtag('set', {'user_id': "${this.props.store.id}"});`
        }
        scriptBody.innerText = text
        document.head.append(scriptBody)
      }
    }, 1000)
    if(!this.props.store.auth && this.props.isView){
      this.setState({
        ctaOpen: true
      })
    }
    const { title } = this.props.workAreaStore
    this.setState({
      title
    })
  }

  toggleUpdate(){
    this.setState({
      updateOpen: !this.state.updateOpen
    })
  }

  openShare(){
    const { store } = this.props
    store.toggleShare(!this.props.store.modals.shareOpen, this.props.workAreaStore.designId)
  }
  
  toggleProjectMenu(){
    if(!this.props.workAreaStore.compiled){
      return
    }
    const { store, store: { subscription } } = this.props
    if(subscription){
      store.toggleAnyModal('projectsOpen', true)
    }else{
      store.toggleUpgradeModal('projects', true)
    }
  }

  openPublish(){
    this.props.saveStore.saveDesign(true)
    const { store } = this.props
    if(store.auth){
      store.togglePublish(!this.props.store.modals.publishOpen, this.props.workAreaStore.designId)
    }else{
      store.toggleUpgradeModal('register', true)
    }
  }

  handleClick(e){
    const { className } = e.target
    const selection = document.getSelection()
    if(selection && selection.anchorNode && selection.anchorNode.className){
      return
    }
    if(className && typeof(className) === 'string' && !className.includes('project') && className.includes('header')){
      this.props.store.closeAll()
    }
  }

  handleChange(e){
    const { name, value } = e.target
    this.setState({
      [name]: value
    })
  }

  setTitle(title){
    this.setState({
      title
    })
  }

  getTitle(value){
    const header = document.querySelector('.header')
    if(header){
      const { clientWidth } = header
      const span = document.createElement('span')
      span.style.fontSize = '14px'
      span.textContent = value
      span.style.opacity = 0
      span.style.position = 'absolute'
      span.style.left = 0
      span.style.zIndex = -100000
      header.appendChild(span)
      let maxWidth = clientWidth * 0.25
      let newVal = value + ' '
      if(span.clientWidth > maxWidth){
        newVal = ''
        const chars = value.split('')
        let set = false
        chars.forEach((char, idx) => {
          if(!set){
            newVal += char
            span.textContent = newVal
            if(span.clientWidth > maxWidth){
              set = true
              newVal = newVal.slice(0, idx - 3) + '... '
            }
          }else{
            return
          }
        })
      }
      span.remove()
      return newVal
    }
  }

  saveChanges(){
    const { workAreaStore, workAreaStore: { title } } = this.props
    const isAdmin = this.props.store.role.level > 1
    if(this.state.title === ''){
      this.setTitle(title)
    }else{
      workAreaStore.setTitle(this.state.title)
    }
    if(isAdmin){
      this.props.saveStore.saveDesign(true, false, true)
    }else{
      this.props.saveStore.saveDesign(true)
    }
    this.setState({
      updateOpen: false
    })
  }

  getStatus(){
    const { saved, saving } = this.props.workAreaStore
    const iconStyle = {
      stroke: '#868789'
    }
    return (
      <span className='header-status'>
        {
          saving ? (
            <div className='saving-wrapper'>
              <Loader className='saving-loader small' />
              <span className='saving-text'>Saving</span>
            </div>
          )
          :
          (
            <>
            {
              saved ? <SavedIcon style={iconStyle} /> : <UnsavedIcon className='unsaved-icon' style={iconStyle} />
            }
            {
              saved ? 'saved' : 'unsaved'
            }
            </>
          )
        }
      </span>
    )
  }

  adminSave(){
    this.props.saveStore.saveDesign(true, false, true)
  }

  toggleAdminModal(){
    this.props.store.toggleAnyModal('adminModalOpen', true)
  }

  toggleModal(name, status){
    this.props.store.toggleAnyModal(name, status)
  }

  back(){
    window.location.href = 'https://mediamodifier.com'
  }

  async handleDuplicateClick(){
    const { store, errorStore } = this.props
    if(store.auth){
      errorStore.setErrorMessage('Duplicating design', false)
      await store.duplicateDesign()
      store.toggleAnyModal('fileOpen', false)
      errorStore.setErrorMessage('Duplicate created!', false)
    }else{
      store.toggleUpgradeModal('register', true)
    }
  }

  deleteDesignPropmt(){
    const { store, errorStore } = this.props
    if(store.auth){
      store.toggleAnyModal('deletePrompt', true)
    }else{
      store.toggleUpgradeModal('register', true)
    }
  }

  createNew(){
    const url = `${window.location.origin}/design-editor/${uuidv4()}`
    window.open(url, '_blank')
  }

  async handleDelete(){
    await this.props.store.setDesignDeleted()
  }

  checkIfQueryParams(){
    if(!this.state.toggled){
      const params = new URLSearchParams(window.location.search)
      if(params.get('customSize')){
        this.props.store.openCustomResolutionTab()
      }
      if(params.get('resolution')){
        const [w, h] = params.get('resolution').split('x')
        if(w && h){
          const width = Number(w)
          const height = Number(h)
          if(!isNaN(width) && !isNaN(height)){
            //set design size
          }
        }
      }
      this.setState({ toggled: true })
    }
  }

  render() {
    const { modals: { menuOpen, projectsOpen, adminModalOpen, modalOpen, nftOpen, deletePrompt, shareModal }, role, auth, modalType } = this.props.store;
    const { workAreaStore, workAreaStore: { compiled, invalidPermissionsModal }, viewStore } = this.props
    let designProps = {
      title: '',
      height: 0,
      width: 0
    }
    if(workAreaStore.pages.length){
      const { height, width } = workAreaStore.pages[0]
      const title = workAreaStore.title
      designProps = {
        title,
        height,
        width
      }
    }
    const { isView } = this.props
    const className = isView ? 'header h-view-only border-bottom' : 'header border-bottom'
    return (
      <header className={className} onClick={e => this.handleClick(e)}>
        <a href='https://mediamodifier.com' className="logo-icon">
          <LogoIcon />
        </a>
        {
          isView ? (
            undefined
          )
          :
          <div className='design-options'>
            <button onClick={() => this.toggleModal('fileOpen', !this.props.store.modals.fileOpen)} className='btn file-btn'>
              File
            </button>
            {
              this.props.store.modals.fileOpen ? (
                <div className='file-menu'>
                  {
                    [
                      {
                        label: 'Create new design',
                        onClick: () => this.createNew(),
                        id: 'new'
                      },
                      {
                        label: 'Duplicate design',
                        onClick: () => this.handleDuplicateClick(),
                        id: 'duplicate'
                      },
                      {
                        label: 'Delete design',
                        onClick: () => this.deleteDesignPropmt(),
                        id: 'design'
                      }
                    ].map((item, idx) => (
                      <div 
                        className='file-menu__btn-wrapper'
                        key={idx}
                      >
                        <button 
                          className='btn file-menu__btn' 
                          onClick={item.onClick}
                        >
                          {item.label}
                        </button>
                      </div>
                    ))
                  }
                </div>
              )
              :
              undefined
            }
          {
            (
              this.state.updateOpen ? (
                <div className='design-title'>
                  <input
                    type='text'
                    className='form-control design-title__input'
                    defaultValue={this.state.title ? this.state.title : designProps.title}
                    onChange={e => this.handleChange(e)}
                    name='title'
                    placeholder='Design name'
                  />
                  <button onClick={() => this.saveChanges()} className='btn btn-bordered'>
                    Update
                  </button>
                  <CaretUp className='up' onClick={this.toggleUpdate.bind(this)} style={{transform: 'rotate(-90deg)'}} />
                </div>
              )
              :
              (
                <div className='design-title closed'>
                  <div className='design-title__closed-wrapper' onClick={this.toggleUpdate.bind(this)}>
                    <span className='design-title__text'>{this.state.title ? this.state.title : designProps.title}</span>
                    <div className='design-title__closed-wrapper__toggle'>
                      <CaretUp className='down' style={{transform: 'rotate(90deg)'}} />
                    </div>
                  </div>
                </div>
              )
            )
          }
          </div>
        }
        {
          <>
          {
            isView ? (
              <div className='h-view-only__title'>
                <span>{viewStore.title}</span><span className='gray'>{viewStore.dimensions.width}px x {viewStore.dimensions.height}px</span>
              </div>
            )
            :
            (
              workAreaStore.mockupBase ? (
                <div className='header-center-element'>
                  {
                    <span>
                      Editing Mockup Layer {designProps.height}px x {designProps.width}px 
                    </span>
                  }
                </div>
              )
              :
              (
                <div className="header-center-element">
                  {
                    <div className='projects-wrapper cursor-pointer' style={{position: 'relative'}}>
                      {workAreaStore.activeBrand ? 
                        (
                          <span className='project-title' onClick={() => this.toggleProjectMenu()}>
                            {workAreaStore.activeBrand.name}
                          </span>
                        )
                        :
                        (
                          <span className='project-title empty' onClick={() => this.toggleProjectMenu()}>
                            No brand selected
                          </span>
                        )
                      }
                      {
                        projectsOpen ? <Projects /> : undefined
                      }
                    </div>
                  } 
                  <span className='header-separator'>/</span>
                  <span
                    className='cursor-pointer'
                    onClick={() => this.toggleModal('menuOpen', !menuOpen)}
                  >
                    {
                      compiled ? (
                        <>
                          <span className='dimensions'>
                            {designProps.width} x {designProps.height}px 
                          </span>
                          {this.checkIfQueryParams()}
                        </>
                      )
                      :
                      (
                        <>
                          {designProps.height}px x {designProps.width}px 
                        </>
                      )
                    }
                  </span>
                  <div className='menu-tools' onClick={() => this.toggleModal('menuOpen', !menuOpen)}>
                    {
                      menuOpen ? <CaretUp /> : <CaretDown />
                    }
                  </div>
                  {
                    menuOpen ? <DesignMenu compiled={this.props.workAreaStore.compiled} /> : undefined
                  }
                </div>
              )
            )
          }
          {
            isView && this.state.ctaOpen ? (
            <CallToAction 
              className={'shared-view-cta'} 
              isView={true}
              openLogin={() => this.props.store.toggleAuthModal(true, 'login')}
              openRegister={() => this.props.store.toggleAuthModal(true, 'register')}
            /> 
            )
            : undefined
          }
          </>
        }
        {
          isView ? (
            <div className='h-view-only__buttons'>
              {
                <>
                  {
                    auth ? (
                      <div />
                    )
                    :
                    undefined
                  }
                  <div className='h-view-only__status'>
                    <LockedIcon />
                    <span>View only</span>
                  </div>
                </>
              }
              <ProfileIcon className="mr-2" />
            </div>
          )
          :
          (
            <div className="header-btn-group">
              {
              <>
                {
                  auth && role.level && (role.level === 2 || role.level === 99) ? (
                    <>
                    {
                      <button 
                        onClick={() => this.toggleAdminModal()}
                        className='btn btn-danger admin-btn'
                      >
                        Edit
                      </button>
                    }
                      <button 
                        className='btn btn-primary admin-btn'
                        onClick={() => this.adminSave()}
                      >
                        Save
                      </button>
                    </>
                  )
                  :
                  undefined
                }
                {this.getStatus()}
                <ShareButton className="mr-2" onClick={() => this.openShare()} />
                {
                  this.props.store.modals.shareOpen ? (<ShareMenu />) : undefined
                }
                <PublishButton className="mr-2" onClick={() => this.openPublish()} />
                <PublishMenu isGif={this.props.store.isGif} />
                <ProfileIcon className="mr-2" />
              </>
              }
            </div>
          )
        }
        {
          modalOpen ? <AuthModal type={modalType} /> : undefined
        }
        {/* {
          shareModal ? <ShareModal /> : undefined
        } */}
        {
          adminModalOpen ? <AdminModal /> : undefined
        }
        {
          deletePrompt ? <ConfirmModal
          closeModal={() => { this.props.store.toggleAnyModal('deletePrompt', false) }}
          handleConfirm={() => this.handleDelete()}
          confirmText={'Delete'}
          cancelText={'Cancel'}
          title={`Confirm the deletion of "${workAreaStore.title}"`}
          body={`Are you sure you want to delete "${workAreaStore.title}". You will not be able to access this design again.`}
          className={'delete-confirmation'}
          /> : undefined
        }
        {
          invalidPermissionsModal ? <PermissionsModal /> : undefined
        }
        {
          nftOpen ? <NFTModal /> : undefined
        }
      </header>
    );
  }
}

export default Header;
